import { call, put, takeEvery } from "redux-saga/effects";

//restapi end point
import * as constClass from "../../../common/constant/constantURL";
// Login Redux States
import {
  EXPORT_ZOHO_PROCESS,
  GET_EXPORT_ZOHO_DATA,
  GET_LOGS_ZOHO_DATA,
  GET_ZOHO_ACCESS,
  GET_ZOHO_COUNT,
  LOGOUT_ZOHO,
} from "./actionTypes";
import {
  exportZohoProcessFailed,
  exportZohoProcessSuccess,
  getExportDataFailed,
  getExportDataSuccess,
  getLogsDataFailed,
  getLogsDataSuccess,
  getZohoAccessFailed,
  getZohoAccessSuccess,
  getZohoCountFailed,
  getZohoCountSuccess,
  logoutZohoFailed,
  logoutZohoSuccess,
} from "./actions";

import { deleteApp, getCall, postCall } from "../../../helpers/fakebackend_helper";
function* getZohoAccessHandler(data) {
  try {
    let dat = data.payload;

    let url;

    url =
      constClass.REST_API_ZOHO_ACCESS +
      `/count?accountserver=${dat.countryCode}`;

    const response = yield call(getCall, url);

    yield put(getZohoAccessSuccess(response));
  } catch (error) {
    yield put(getZohoAccessFailed(error));
  }
}

function* getZohoCountHandler(user) {
  try {
    let url;

    let data = user.payload;

    url = constClass.REST_API_ZOHO_ACCESS + `?code=${data.code}`;

    const response = yield call(getCall, url);

    yield put(getZohoCountSuccess(response));
  } catch (error) {
    yield put(getZohoCountFailed(error));
  }
}
function* exportZohoHandler(user) {
  try {
    let url;
    let data = user.payload;

    url = constClass.REST_API_ZOHO_PROCESS;

    yield call(postCall, url, data);

    yield put(exportZohoProcessSuccess("Process in queue"));
  } catch (error) {
    yield put(exportZohoProcessFailed(error));
  }
}

function* getExportDataHandler(user) {
  try {
    let url;

    let data = user.payload;

    url =
      constClass.REST_API_ZOHO_PROCESS +
      `?fileType=${data.exportType}&page=${data.pageNumber}&pageSize=${data.pageSize}`;

    const response = yield call(getCall, url);

    yield put(getExportDataSuccess(response));
  } catch (error) {
    yield put(getExportDataFailed(error));
  }
}
function* getLogsDataHandler(user) {
  try {
    let url;

    let data = user.payload;

    url =
      constClass.REST_API_ZOHO_PROCESS +
      `/log?requestId=${data.id}&page=${data.pageNumber}&pageSize=${data.pageSize}`;

    const response = yield call(getCall, url);

    yield put(getLogsDataSuccess(response));
  } catch (error) {
    yield put(getLogsDataFailed(error));
  }
}

function* zohoLogoutHandler() {
  try {
  let url =
      constClass.REST_API_ZOHO_ACCESS_LOGOUT ;

      yield call(deleteApp, url);

    yield put(logoutZohoSuccess("Logout Successfully"));
  } catch (error) {
    yield put(logoutZohoFailed(error));
  }
}

function* zohoIntegrationSaga() {
  yield takeEvery(GET_ZOHO_ACCESS, getZohoAccessHandler);
  yield takeEvery(GET_ZOHO_COUNT, getZohoCountHandler);
  yield takeEvery(EXPORT_ZOHO_PROCESS, exportZohoHandler);
  yield takeEvery(GET_EXPORT_ZOHO_DATA, getExportDataHandler);
  yield takeEvery(GET_LOGS_ZOHO_DATA, getLogsDataHandler);
  yield takeEvery(LOGOUT_ZOHO, zohoLogoutHandler);
}

export default zohoIntegrationSaga;
